export const PATIENT_SERVICES = {
  PAE: 'PAE',
  PRIVATE: 'PRIVATE',
  SAPA: 'SAPA',
  INSURANCE: 'INSURANCE',
  TRAINING: 'TRAINING',
} as const;
